



























import { defineComponent, reactive } from '@vue/composition-api';
import { useRouter } from '@ideavivat/vivat-2';
import CommonVisitorSelector from '@/components/Visitor/CommonVisitorSelector.vue';

import {
  answerQuestion,
} from '@/api';

const InitialSession = defineComponent({
  components: {
    CommonVisitorSelector,
  },
  setup() {
    const { route, router } = useRouter();

    const form = reactive({
      user: null,
      message: '',
      call: async () => {
        const result = await answerQuestion(
          form.message,
          route.value.params.liveId,
          (form.user as any).id as any,
        );

        if (result.user_id) {
          router.push({
            name: 'QAChatUser',
            params: {
              liveId: route.value.params.liveId,
              userId: result.user_id,
            },
          });
        }
      },
    });

    return {
      form,
    };
  },
});

export default InitialSession;
